// domain.com.au rejects listing descriptions longer than this (HTTP 400,
// "Description should be 6000 characters."). The backend trims at the last
// paragraph break under the cap before sending (DomainIntegration.fit_description),
// so a long description still publishes, just shortened. REA has no such cap.
export const DOMAIN_DESCRIPTION_MAX = 6000;

// Mirror of the backend trim so the editor can show roughly where Domain's
// version will end. Keep in step with domain_integration.fit_description.
export function fitDomainDescription(text, limit = DOMAIN_DESCRIPTION_MAX) {
  const value = text || "";
  if (value.length <= limit) return value;
  const head = value.slice(0, limit);
  let cut = head.lastIndexOf("\n\n");
  if (cut < limit / 2) {
    const sentence = Math.max(head.lastIndexOf(". "), head.lastIndexOf(".\n"));
    cut = sentence >= limit / 2 ? sentence + 1 : -1;
  }
  if (cut < limit / 2) cut = head.lastIndexOf(" ");
  if (cut <= 0) cut = limit;
  return head.slice(0, cut).trimEnd();
}

export function domainDescriptionStatus(text) {
  const length = (text || "").length;
  const over = length > DOMAIN_DESCRIPTION_MAX;
  return {
    length,
    over,
    shown: over ? fitDomainDescription(text).length : length,
    limit: DOMAIN_DESCRIPTION_MAX,
  };
}

// Pull the Domain-only advisory out of a save response. Both save paths carry
// it: the property PUT as `domain_sync.warnings`, the crawler PATCH as the
// `portal_sync` entry whose portal is "domain". REA entries never have it.
export function domainWarningsFromResponse(data) {
  const fromSync = data?.domain_sync?.warnings;
  if (Array.isArray(fromSync) && fromSync.length) return fromSync;
  const entry = (data?.portal_sync || []).find((r) => r?.portal === "domain");
  return Array.isArray(entry?.warnings) && entry.warnings.length ? entry.warnings : [];
}
